import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 0,
    user: JSON.parse(localStorage.getItem('user')),
    userProfile: null,
    isAuthenticated: !! localStorage.getItem('access_token'),
    invitee: null,
    pool: null,
    pools: [],
    invited_contributors: null,
    pool_contributors: [],
    pool_convener: null,
    payout_candidates: null,
    payout_request_info: null,
    user_payout_approval_status: null,
    oa_payout_info: null,
    pool_disbursed_info: [],
    loading_state: false
  
  },

  getters: {
      isAuth: (state) => state.isAuthenticated,

      user: (state) => state.user,

      userProfile: (state) => state.userProfile,

      invitee: (state) => state.invitee,

      pool: (state) => state.pool,

      pools: (state) => state.pools,

      latest_pool: (state) => state.pools.length < 1 ? null : state.pools[0],

      pool_contributors: ( state ) => state.pool_contributors,

      pool_invitees: (state) => state.invited_contributors,

      pool_convener: (state) => state.pool_convener,

      invite_detail: (state, getters) => {

        const { userProfile, pool } = getters;

        if (pool != null && userProfile != null) {

          let invite_detail = pool.invitees.filter(p => p.email == userProfile.email);
  
          return invite_detail.length == 0 ? [] : invite_detail[0];
        }
      },
      
      payout_candidates: (state) => state.payout_candidates,

      payout_request_info: (state) => state.payout_request_info,

      user_payout_approval_status: (state) => state.user_payout_approval_status,

      oa_payout_info: (state) => state.oa_payout_info,

      pool_disbursed_info: (state) => state.pool_disbursed_info

  },

  mutations: {
    increment (state) {
      state.count++
    },
    SET_USER_PROFILE (state, profile) {
      state.userProfile = profile;
    },
    SET_INVITEE (state, payload) {
      state.invitee = payload;
    },
    SET_POOL (state, pool_data) {
      state.pool = pool_data;
    },
    SET_POOLS (state, pools) {
      state.pools = pools;
    },
    SET_INVITEES (state, invitees) {
      state.invited_contributors = invitees;
    },
    SET_POOL_CONTRIBUTORS (state, contributors) {
      state.pool_contributors = contributors;
    },
    UPDATE_BANK_DETAILS (state, bank_details) {
      state.userProfile.bank_details = bank_details;
    },
    SET_POOL_CONVENER (state, convener) {
      state.pool_convener = convener;
    },
    SET_PAYOUT_CANDIDATES (state, candidates) {
      state.payout_candidates = candidates
    },
    SET_PAYOUT_REQUEST_INFO (state, data) {
      state.payout_request_info = data;
    },
    USER_PAYOUT_APPROVAL_STATUS (state, message) {
      state.user_payout_approval_status = message;
    },
    SET_OA_PAYOUT_INFO (state, info) {
      state.oa_payout_info = info;
    },
    SET_POOL_DISBURSED (state, payload) {
      state.pool_disbursed_info = payload
    },
    SET_LOADING_STATE (state, value) {
      state.loading_state = value
    }
    
  },

  actions: {
    async getUserProfile({commit}) {
      try {
        const user =  await axios.post('/auth/me');

        if (user.status == 200) {
          commit('SET_USER_PROFILE', user.data);
        }
      } catch (error) {
        // console.log(error.response);
      }
    },

    async updateProfile({commit}, payload) {

      try {
        const update = await axios.post('/auth/me/update', payload);

        return update;

      } catch (error) {
        // console.log(error.response);
      }
    },

    async getInviteeDetails({commit}, invite_id) {
      try {
          const invitee = await axios.post(`/pool/invitee/${invite_id}`);

          if (invitee.status == 200 ) {
              const invitee_details = invitee.data.message;

              commit ('SET_INVITEE', invitee_details);
          }
      } catch (error) {

      }
    },

    async getPools ({ commit }) {

      commit('SET_LOADING_STATE', true)

      try {
          const pools = await axios.post('/pool/me');

          commit('SET_LOADING_STATE', false)

          if (pools.data.status == 'ok' && pools.status == 200) {
              const { my_pools, joined_pools } = pools.data.message;

              const allPools = [...my_pools, ...joined_pools];

              console.log({'mypools':my_pools, 'joined':joined_pools})
              commit('SET_POOLS', allPools.reverse());
          }
      } catch (error) {
          commit('SET_LOADING_STATE', false)

          console.log(error)
      }
    },

    async getPool ({ commit }, pool_id) {
      try {
        const pool = await axios.post(`/pool/get/${pool_id}`);

          if (pool.status == 200 && pool.data.status == 'ok') {
            const pool_data = pool.data.message;

            commit('SET_POOL', pool_data);
          }

      } catch (error) {
          console.log(error.response);
      }
    },

    async getPoolConvener({ commit }, account_id) {
      try {
        const convener = await axios.post(`/auth/getuser/${account_id}`);

        if (convener.status == 200) {
            commit('SET_POOL_CONVENER', convener.data);
        }        
      } catch (error) {
          console.log(error.response);
      }
    },

    async listInvitedContributors({ commit }, pool_id) {
      try {
          const invitees = await axios.post('/pool/invited', {'pool_id': pool_id});

          // console.log(invitees)
          if (invitees.status == 200) {
              const contributors = invitees.data.message;

              if ('organizer' in contributors) {

                const { members, organizer } = contributors;

                const pool_members = { members, organizer }
                
                commit('SET_INVITEES', pool_members);

              } else {
                commit('SET_INVITEES', contributors);
              }

          }
      } catch(error) {
          // console.log(error.response);
      }
    },

    async listPaidContributors({ commit }, pool_id) {
      try {
          const paid_contributors = await axios.post('/pool/contributors', {'pool_id': pool_id});

          if (paid_contributors.status == 200) {
              const contributors = paid_contributors.data.message;

              commit('SET_POOL_CONTRIBUTORS', contributors);
          }
      } catch (error) {
          console.log(error.response);
      }
    },

    async getPayoutCandidates({ commit }, pool_id) {

      const data = {
          pool_id: pool_id
      }
      commit('SET_LOADING_STATE', true);

      try {
          const candidates = await axios.post('/pool/payout/request/candidates', data);

          commit('SET_LOADING_STATE', false)
          if (candidates.status == 200) {
            const { message } = candidates.data;

            if (message.length == 0) {
              commit('SET_PAYOUT_CANDIDATES', null);
            } else {
              commit('SET_PAYOUT_CANDIDATES', message);
            }
          }
      } catch (error) {
        commit('SET_LOADING_STATE', false)

      }
    },

    async payoutRequestInfo({ commit }, pool_id) {

      try {
          const info = await axios.post('/pool/payout/request/getinfo', { pool_id: pool_id });

          if (info.status == 200 && info.data.status == 'ok' && 'message' in info.data) {

            commit('SET_PAYOUT_REQUEST_INFO', info.data.message); 
          }
      } catch (error) {
          console.log(error.response)
      }
    },
    
    async updateBankDetails({ commit }, bank_details) {

      console.log(bank_details)
      // try {
      //   const bank_details = await axios.post('/');

      //   console.log(bank_details);
      // } catch (error) {
      //   console.log(error.response);
      // }
    },

    async getPayoutVotesInfo({ commit }, account_id) {
      try {
          const votes_info = await axios.post(
              '/pool/payout/request/getinfodecided', { account_id: account_id }
          );
          // console.log(votes_info);

          const { message } = votes_info.data;

          commit('USER_PAYOUT_APPROVAL_STATUS', message);
      } catch (error) {
          console.log(error.response);
      }
    },

    async getOrgAutonomyInfo({ commit }, pool_id) {

      commit('SET_LOADING_STATE', true);

      try {
          const info = await axios.post('/pool/payout/getinfo', { pool_id: pool_id});

          commit('SET_LOADING_STATE', false)

          if (info.status == 200 && info.data.status == 'ok') {
              commit('SET_OA_PAYOUT_INFO', info.data.message);
          }
      } catch (error) {
        commit('SET_LOADING_STATE', false)

      }
    },

    async getDisbursedPayouts({ commit }, pool_id) {
      try {
          const paid_payouts = await axios.post('/pool/payout/get_paid_payouts', { pool_id: pool_id });
          console.log(paid_payouts);

          if (paid_payouts == 200) {
            commit('SET_POOL_DISBURSED', paid_payouts.data.message);
          }

      } catch (error) {
          console.log(error.response)
      }
    }
  }
});